<script setup lang="ts">
import { arrowForward } from "ionicons/icons";
import {
  IonButton,
  IonIcon,
  IonPage,
  IonContent,
  useIonRouter,
} from "@ionic/vue";
const router = useIonRouter();
const goToEvent = () => {
  router.push(`/onboarding/new-event`);
};

const goToHome = () => {
  router.push(`/home`);
}
</script>

<template>
  <ion-page>
    <ion-content class="ion-text-center">
      <div class="container">
        <section>
          <hr />
          <h1 class="ion-margin">Welcome to Event Check-In App</h1>

          <img src="@/assets/ready.png" />
          <hr />
          <h4>Let’s get started</h4>
          <p>Begin by creating your first event</p>

          <hr />
        </section>
      </div>
      <ion-button size="large" color="light" @click="goToEvent()">
        <ion-icon slot="start" :icon="arrowForward"></ion-icon>
        Create event
      </ion-button>
    </ion-content>
    <ion-footer class="ion-text-center">
      <ion-button size="small" color="light" fill="clear" @click="goToHome()">
        SKIP
      </ion-button>
    </ion-footer>
  </ion-page>
</template>

<style lang="scss" scoped>
ion-content {
  --ion-background-color: var(--ion-color-primary, #fff);

  .container {}
}

ion-footer {
  background: var(--ion-color-primary);
}
</style>
